export default __webpack_public_path__ + "static/logo_majestic-ccf646b5dd0f4eb05777caf5dbc1ba9f.png";